module.exports = __webpack_public_path__ + "img/account.0bbe315e.png";